import React from 'react';
import { find } from 'lodash';

// local dependencies
import { withHeaderAndFooter } from 'ui/hoc/withHeaderAndFooter';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { sidebarNav as SidebarNavView } from 'ui/views/widgets/sidebarNav';
import { AccessManagementUserGroups } from 'ui/containers/AccessManagementUserGroups';
import { AccessManagementPermissions } from 'ui/containers/AccessManagementPermissions';
import { ACCESS_MANAGEMENT_TABS } from 'constants/common';

const TAB_VIEWS = {
    [ ACCESS_MANAGEMENT_TABS.USER_GROUPS ]: AccessManagementUserGroups,
    [ ACCESS_MANAGEMENT_TABS.PERMISSIONS ]: AccessManagementPermissions
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { accessManagement as AccessManagement } from 'ui/views/widgets/accessManagement';
 *
 * // render
 * <AccessManagement propName='propValue'/>
 */
const _accessManagement = ( props ) => {
    const { selectedTab, onTabChange, componentData } = props;
    const { tabs } = componentData;

    const TabView = TAB_VIEWS[ selectedTab ];

    return (
        <div className='ui-access-management'>
            <div className='ui-access-management__sidebar'>
                <SidebarNavView tabs={ tabs } selectedTab={ selectedTab } onTabChange={ onTabChange } />
            </div>
            <div className='ui-access-management__main'>
                {
                    selectedTab ? (
                        <TabView
                            widget={ find( tabs, { name: selectedTab } ) }
                        />
                    ) : null
                }
            </div>
        </div>
    );
};

// set display name
_accessManagement.displayName = 'accessManagement';

// set default props
_accessManagement.defaultProps = {};

// prop types
_accessManagement.propTypes = {};

export const accessManagement = withNetworkState( HeartBeatPreloader, withHeaderAndFooter( _accessManagement ) );
